import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { COLORS } from "../utils/colors";

function CircularLoader({ color, size, sx }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress disableShrink sx={{ color: color ?? COLORS.OXYGEN7_PURPLE, ...sx }} size={size} />
    </Box>
  );
}
export default CircularLoader;
